import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/App";
import "@/styles/globals.css";

const container = document.getElementById("root");
if (!container) throw new Error("Нет #root — index.html не тот");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
